import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "contents-sub-title-text brg-color-grey-800 mb-1 d-ib"
};
import { computed, ref, toRefs, watch, } from 'vue';
import { useRoute, useRouter, } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchInput',
    props: {
        title: { default: '' },
        width: { default: 300 },
        btnWidth: { default: undefined },
        onSearch: { type: Function, default: () => { } },
        placeholder: { default: '' },
        disabledResetIcon: { type: Boolean, default: false },
        outlined: { type: Boolean, default: true },
        defaultValue: { default: '' },
        isDisabled: { type: Boolean, default: false },
        btnText: { default: '검색' },
        isHideSearchBtn: { type: Boolean, default: false }
    },
    setup(__props, { expose: __expose }) {
        // 검색 버튼이 있는 text field
        const route = useRoute();
        const router = useRouter();
        // 검색 버튼이 있는 텍스트 인풋
        const props = __props;
        const { width, defaultValue, placeholder, outlined, isDisabled, disabledResetIcon, } = toRefs(props);
        const text = ref('');
        const appendIcon = computed(() => {
            if (disabledResetIcon.value) {
                return '';
            }
            return text.value ? 'mdi-close' : '';
        });
        const wrapperWidth = computed(() => {
            if (width.value === '100%') {
                return '';
            }
            if (typeof width.value === 'string') {
                return `width: ${width.value}`;
            }
            if (width.value && width.value > 0) {
                return `width: ${width.value}px;`;
            }
            return '';
        });
        const variant = computed(() => (props.outlined ? 'outlined' : 'solo'));
        const backgroundColor = computed(() => (props.outlined ? 'white' : ''));
        const resetQueryString = () => {
            const { 
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            searchWord, ...rest } = route.query;
            router
                .replace({
                query: rest,
            })
                .catch(() => { });
        };
        /**
         * 검색 버튼 클릭 핸들러
         */
        const resetValue = () => {
            text.value = '';
        };
        /**
         * 검색 버튼 클릭 핸들러
         */
        const handleClickSearchBtn = () => {
            props.onSearch(text.value);
        };
        /**
         * enter 키 프레스 핸들러
         */
        const handleEnterInput = () => {
            props.onSearch(text.value);
        };
        /**
         * 제거 아이콘 클릭 핸들러
         */
        const handleClickAppendIcon = () => {
            resetValue();
        };
        watch(() => defaultValue.value, (watchValue) => {
            if (!watchValue) {
                resetQueryString();
            }
            text.value = watchValue;
        });
        text.value = defaultValue.value;
        __expose({
            resetValue,
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle(wrapperWidth.value),
                class: "brg-input-section search-input"
            }, [
                (_ctx.title)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                    class: _normalizeClass(["search-input-inner", { 'input-field-only': _ctx.isHideSearchBtn }])
                }, [
                    _createCommentVNode(" 텍스트 필드 "),
                    _createVNode(_component_v_text_field, {
                        modelValue: text.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((text).value = $event)),
                        density: "compact",
                        placeholder: _unref(placeholder),
                        variant: variant.value,
                        "bg-color": backgroundColor.value,
                        disabled: _unref(isDisabled),
                        outlined: _unref(outlined),
                        solo: !_unref(outlined),
                        "hide-details": "",
                        "append-inner-icon": appendIcon.value,
                        onKeypress: _withKeys(_withModifiers(handleEnterInput, ["prevent"]), ["enter"]),
                        "onClick:appendInner": handleClickAppendIcon
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "variant", "bg-color", "disabled", "outlined", "solo", "append-inner-icon", "onKeypress"]),
                    _createCommentVNode(" 검색 버튼 "),
                    (!_ctx.isHideSearchBtn)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            width: _ctx.btnWidth,
                            class: "brg-btn outlined info size-l",
                            onClick: handleClickSearchBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-magnify ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _cache[2] || (_cache[2] = _createTextVNode(" 검색 "))
                            ]),
                            _: 1 /* STABLE */,
                            __: [2]
                        }, 8 /* PROPS */, ["width"]))
                        : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */)
            ], 4 /* STYLE */));
        };
    }
});
